import { Product, RecipeBundleType } from '../types'

export const mockProducts: Product[] = [
  // Produce
  {
    id: 'prod-001',
    name: 'Fresh Plantains (Ripe)',
    price: 1.49,
    category: 'Produce',
    image:
      'https://images.unsplash.com/photo-1603052875302-d376b7c0638a?w=400&h=400&fit=crop',
    altText: 'Bunch of ripe yellow plantains',
    isWIC: true,
    isEBT: true,
    unit: 'per lb',
    origin: 'Ecuador',
  },
  {
    id: 'prod-002',
    name: 'Green Plantains',
    price: 1.29,
    category: 'Produce',
    image:
      'https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=400&h=400&fit=crop',
    altText: 'Fresh green plantains',
    isWIC: true,
    isEBT: true,
    unit: 'per lb',
    origin: 'Costa Rica',
  },
  {
    id: 'prod-003',
    name: 'African Yams (Puna)',
    price: 3.99,
    category: 'Produce',
    image:
      'https://images.unsplash.com/photo-1590165482129-1b8b27698780?w=400&h=400&fit=crop',
    altText: 'Large African yam',
    isWIC: false,
    isEBT: true,
    unit: 'per lb',
    origin: 'Ghana',
  },
  {
    id: 'prod-004',
    name: 'Fresh Cassava (Yuca)',
    price: 2.49,
    category: 'Produce',
    image:
      'https://images.unsplash.com/photo-1598170845058-32b9d6a5da37?w=400&h=400&fit=crop',
    altText: 'Fresh cassava roots',
    isWIC: false,
    isEBT: true,
    unit: 'per lb',
    origin: 'Nigeria',
  },
  {
    id: 'prod-005',
    name: 'Scotch Bonnet Peppers',
    price: 4.99,
    category: 'Produce',
    image:
      'https://images.unsplash.com/photo-1583119022894-919a68a3d0e3?w=400&h=400&fit=crop',
    altText: 'Colorful scotch bonnet peppers',
    isWIC: true,
    isEBT: true,
    unit: 'per lb',
    origin: 'Jamaica',
  },
  {
    id: 'prod-006',
    name: 'Fresh Okra',
    price: 3.49,
    category: 'Produce',
    image:
      'https://images.unsplash.com/photo-1425543103986-22abb7d7e8d2?w=400&h=400&fit=crop',
    altText: 'Fresh green okra',
    isWIC: true,
    isEBT: true,
    unit: 'per lb',
    origin: 'Local',
  },
  // Grains & Flours
  {
    id: 'grain-001',
    name: 'Fufu Flour (Plantain)',
    price: 6.99,
    category: 'Grains & Flours',
    image:
      'https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?w=400&h=400&fit=crop',
    altText: 'Bag of plantain fufu flour',
    isWIC: false,
    isEBT: true,
    unit: '2 lb bag',
    origin: 'Ghana',
  },
  {
    id: 'grain-002',
    name: 'Garri (White)',
    price: 5.49,
    category: 'Grains & Flours',
    image:
      'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=400&h=400&fit=crop',
    altText: 'White garri in bowl',
    isWIC: false,
    isEBT: true,
    unit: '2 lb bag',
    origin: 'Nigeria',
  },
  {
    id: 'grain-003',
    name: 'Jollof Rice Mix',
    price: 4.99,
    category: 'Grains & Flours',
    image:
      'https://images.unsplash.com/photo-1596560548464-f010549b84d7?w=400&h=400&fit=crop',
    altText: 'Jollof rice seasoning mix',
    isWIC: false,
    isEBT: true,
    unit: '12 oz',
    origin: 'Nigeria',
  },
  {
    id: 'grain-004',
    name: 'Semolina (Semovita)',
    price: 7.99,
    category: 'Grains & Flours',
    image:
      'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=400&h=400&fit=crop',
    altText: 'Semolina flour bag',
    isWIC: false,
    isEBT: true,
    unit: '2 lb bag',
    origin: 'Nigeria',
  },
  {
    id: 'grain-005',
    name: 'Egusi (Ground Melon Seeds)',
    price: 8.99,
    category: 'Grains & Flours',
    image:
      'https://images.unsplash.com/photo-1615485290382-441e4d049cb5?w=400&h=400&fit=crop',
    altText: 'Ground egusi seeds',
    isWIC: false,
    isEBT: true,
    unit: '8 oz',
    origin: 'Nigeria',
  },
  // Spices
  {
    id: 'spice-001',
    name: 'Suya Spice Mix',
    price: 5.99,
    category: 'Spices',
    image:
      'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?w=400&h=400&fit=crop',
    altText: 'Suya spice blend',
    isWIC: false,
    isEBT: true,
    unit: '4 oz',
    origin: 'Nigeria',
  },
  {
    id: 'spice-002',
    name: 'Cameroon Pepper',
    price: 6.49,
    category: 'Spices',
    image:
      'https://images.unsplash.com/photo-1599909533681-74084861b728?w=400&h=400&fit=crop',
    altText: 'Ground cameroon pepper',
    isWIC: false,
    isEBT: true,
    unit: '4 oz',
    origin: 'Cameroon',
  },
  {
    id: 'spice-003',
    name: 'Crayfish (Ground)',
    price: 7.99,
    category: 'Spices',
    image:
      'https://images.unsplash.com/photo-1599909533681-74084861b728?w=400&h=400&fit=crop',
    altText: 'Ground dried crayfish',
    isWIC: false,
    isEBT: true,
    unit: '4 oz',
    origin: 'Nigeria',
  },
  {
    id: 'spice-004',
    name: 'Jerk Seasoning',
    price: 4.49,
    category: 'Spices',
    image:
      'https://images.unsplash.com/photo-1532336414038-cf19250c5757?w=400&h=400&fit=crop',
    altText: 'Jamaican jerk seasoning',
    isWIC: false,
    isEBT: true,
    unit: '6 oz',
    origin: 'Jamaica',
  },
  {
    id: 'spice-005',
    name: 'Curry Powder (Jamaican)',
    price: 3.99,
    category: 'Spices',
    image:
      'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?w=400&h=400&fit=crop',
    altText: 'Jamaican curry powder',
    isWIC: false,
    isEBT: true,
    unit: '4 oz',
    origin: 'Jamaica',
  },
  // Oils
  {
    id: 'oil-001',
    name: 'Red Palm Oil',
    price: 8.99,
    category: 'Oils',
    image:
      'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?w=400&h=400&fit=crop',
    altText: 'Bottle of red palm oil',
    isWIC: false,
    isEBT: true,
    unit: '32 oz',
    origin: 'Ghana',
  },
  {
    id: 'oil-002',
    name: 'Coconut Oil (Virgin)',
    price: 9.99,
    category: 'Oils',
    image:
      'https://images.unsplash.com/photo-1526947425960-945c6e72858f?w=400&h=400&fit=crop',
    altText: 'Virgin coconut oil jar',
    isWIC: false,
    isEBT: true,
    unit: '16 oz',
    origin: 'Jamaica',
  },
  {
    id: 'oil-003',
    name: 'Shea Butter (Cooking)',
    price: 12.99,
    category: 'Oils',
    image:
      'https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?w=400&h=400&fit=crop',
    altText: 'Raw shea butter',
    isWIC: false,
    isEBT: true,
    unit: '16 oz',
    origin: 'Ghana',
  },
  // Frozen
  {
    id: 'frozen-001',
    name: 'Frozen Goat Meat',
    price: 11.99,
    category: 'Frozen',
    image:
      'https://images.unsplash.com/photo-1602470520998-f4a52199a3d6?w=400&h=400&fit=crop',
    altText: 'Frozen goat meat package',
    isWIC: false,
    isEBT: true,
    unit: 'per lb',
    origin: 'USA',
  },
  {
    id: 'frozen-002',
    name: 'Frozen Tilapia',
    price: 7.99,
    category: 'Frozen',
    image:
      'https://images.unsplash.com/photo-1544943910-4c1dc44aab44?w=400&h=400&fit=crop',
    altText: 'Frozen tilapia fish',
    isWIC: false,
    isEBT: true,
    unit: 'per lb',
    origin: 'USA',
  },
  {
    id: 'frozen-003',
    name: 'Frozen Stockfish',
    price: 14.99,
    category: 'Frozen',
    image:
      'https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=400&h=400&fit=crop',
    altText: 'Frozen stockfish',
    isWIC: false,
    isEBT: true,
    unit: 'per lb',
    origin: 'Norway',
  },
  {
    id: 'frozen-004',
    name: 'Oxtail',
    price: 9.99,
    category: 'Frozen',
    image:
      'https://images.unsplash.com/photo-1607623814075-e51df1bdc82f?w=400&h=400&fit=crop',
    altText: 'Frozen oxtail pieces',
    isWIC: false,
    isEBT: true,
    unit: 'per lb',
    origin: 'USA',
  },
  // Snacks
  {
    id: 'snack-001',
    name: 'Chin Chin',
    price: 4.99,
    category: 'Snacks',
    image:
      'https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=400&h=400&fit=crop',
    altText: 'Nigerian chin chin snack',
    isWIC: false,
    isEBT: true,
    unit: '8 oz',
    origin: 'Nigeria',
  },
  {
    id: 'snack-002',
    name: 'Plantain Chips',
    price: 3.49,
    category: 'Snacks',
    image:
      'https://images.unsplash.com/photo-1566478989037-eec170784d0b?w=400&h=400&fit=crop',
    altText: 'Crispy plantain chips',
    isWIC: false,
    isEBT: true,
    unit: '5 oz',
    origin: 'Jamaica',
  },
  {
    id: 'snack-003',
    name: 'Puff Puff Mix',
    price: 5.49,
    category: 'Snacks',
    image:
      'https://images.unsplash.com/photo-1517433367423-c7e5b0f35086?w=400&h=400&fit=crop',
    altText: 'Puff puff dough mix',
    isWIC: false,
    isEBT: true,
    unit: '16 oz',
    origin: 'Nigeria',
  },
  // Beverages
  {
    id: 'bev-001',
    name: 'Malt Drink',
    price: 2.49,
    category: 'Beverages',
    image:
      'https://images.unsplash.com/photo-1527960471264-932f39eb5846?w=400&h=400&fit=crop',
    altText: 'Bottle of malt drink',
    isWIC: false,
    isEBT: true,
    unit: '12 oz',
    origin: 'Nigeria',
  },
  {
    id: 'bev-002',
    name: 'Ginger Beer',
    price: 2.99,
    category: 'Beverages',
    image:
      'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62?w=400&h=400&fit=crop',
    altText: 'Jamaican ginger beer',
    isWIC: false,
    isEBT: true,
    unit: '12 oz',
    origin: 'Jamaica',
  },
  {
    id: 'bev-003',
    name: 'Hibiscus Tea (Zobo)',
    price: 4.99,
    category: 'Beverages',
    image:
      'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=400&h=400&fit=crop',
    altText: 'Dried hibiscus flowers for tea',
    isWIC: false,
    isEBT: true,
    unit: '4 oz',
    origin: 'Nigeria',
  },
  // Canned Goods
  {
    id: 'can-001',
    name: 'Palm Fruit Cream',
    price: 3.99,
    category: 'Canned Goods',
    image:
      'https://images.unsplash.com/photo-1584568694244-14fbdf83bd30?w=400&h=400&fit=crop',
    altText: 'Canned palm fruit cream',
    isWIC: false,
    isEBT: true,
    unit: '14 oz',
    origin: 'Ghana',
  },
  {
    id: 'can-002',
    name: 'Ackee (Canned)',
    price: 6.99,
    category: 'Canned Goods',
    image:
      'https://images.unsplash.com/photo-1584568694244-14fbdf83bd30?w=400&h=400&fit=crop',
    altText: 'Canned Jamaican ackee',
    isWIC: false,
    isEBT: true,
    unit: '19 oz',
    origin: 'Jamaica',
  },
  {
    id: 'can-003',
    name: 'Coconut Milk',
    price: 2.99,
    category: 'Canned Goods',
    image:
      'https://images.unsplash.com/photo-1550411294-875e0b3a5f7c?w=400&h=400&fit=crop',
    altText: 'Canned coconut milk',
    isWIC: true,
    isEBT: true,
    unit: '13.5 oz',
    origin: 'Thailand',
  },
]

export const recipeBundles: RecipeBundleType[] = [
  {
    id: 'bundle-001',
    title: 'Jollof Rice Night',
    description: 'Everything you need for authentic Nigerian jollof rice',
    productIds: ['grain-003', 'oil-001', 'spice-002', 'prod-005'],
    savings: 2.5,
  },
  {
    id: 'bundle-002',
    title: 'Egusi Soup Starter',
    description: 'Traditional egusi soup ingredients',
    productIds: ['grain-005', 'oil-001', 'spice-003', 'prod-006'],
    savings: 3.0,
  },
  {
    id: 'bundle-003',
    title: 'Caribbean Curry Kit',
    description: 'Make authentic Jamaican curry at home',
    productIds: ['spice-004', 'spice-005', 'prod-005', 'oil-002'],
    savings: 2.0,
  },
  {
    id: 'bundle-004',
    title: 'Fufu & Soup Essentials',
    description: 'Classic fufu with all the fixings',
    productIds: ['grain-001', 'grain-005', 'oil-001', 'spice-003'],
    savings: 3.5,
  },
]

export const categories = [
  'All',
  'Produce',
  'Grains & Flours',
  'Spices',
  'Oils',
  'Frozen',
  'Snacks',
  'Beverages',
  'Canned Goods',
] as const

export function getProductById(id: string): Product | undefined {
  return mockProducts.find((p) => p.id === id)
}

export function getProductsByCategory(category: string): Product[] {
  if (category === 'All') return mockProducts
  return mockProducts.filter((p) => p.category === category)
}

export function searchProducts(query: string): Product[] {
  const lowerQuery = query.toLowerCase()
  return mockProducts.filter(
    (p) =>
      p.name.toLowerCase().includes(lowerQuery) ||
      p.category.toLowerCase().includes(lowerQuery) ||
      p.origin?.toLowerCase().includes(lowerQuery),
  )
}

export function getBundleProducts(bundle: RecipeBundleType): Product[] {
  return bundle.productIds
    .map((id) => getProductById(id))
    .filter((p): p is Product => p !== undefined)
}

export function getBundleTotalPrice(bundle: RecipeBundleType): number {
  const products = getBundleProducts(bundle)
  return products.reduce((sum, p) => sum + p.price, 0) - bundle.savings
}
